import { event, engagement } from '@blocket/tracking-pulse'
import gtm from '@blocket/tracking-gtm'
import log from 'sentry/log'

export const profilePagePrivateView = () => {
  try {
    // view page should generally always have a gtm.pageView event as well. For marknad to use.
    gtm.pageView({ id: 'profile-page-private' })

    event({
      type: 'View',
      name: 'View Private Profile Page',
      object: {
        type: 'Page',
        id: 'profile_page_private',
      },
    })
  } catch (error) {
    log.message(`Private Profile Page tracking error ${error}`)
  }
}

export const bankIdPromotionView = () => {
  try {
    event({
      type: 'View',
      name: 'View BankId Promotion Private Profile Page',
      object: {
        type: 'UIElement',
        id: 'profile_page_private:bankid_promotion',
      },
    })
  } catch (error) {
    log.message(`Private Profile Page tracking error; View BankId Promotion ${error}`)
  }
}

export const trackBankIdClickEvent = () => {
  try {
    engagement({
      action: 'Click',
      name: 'Clicked on bankId promotion, private profile',
      object: {
        id: 'profile_page_private:bankid_promotion_verify_account',
        type: 'UIElement',
      },
    })
  } catch (error) {
    log.message(`Private Profile Page tracking error; BankId verify event ${error}`)
  }
}

export const changeNameClickEvent = (updateProfileUrl) => {
  try {
    engagement({
      action: 'Click',
      name: 'Clicked on change name link',
      object: {
        id: 'profile_page_private_change_name',
        type: 'UIElement',
      },
      target: {
        id: updateProfileUrl,
        type: 'Page',
      },
    })
  } catch (error) {
    log.message(`Private Profile Page tracking error; Change name event ${error}`)
  }
}
